<template>
  <div id="content-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-2 pb-4">
            <b-button block variant="primary" outline size="lg" @click="toAddModalOpened=true">
              <i class="fas fa-plus"></i>
              Add
            </b-button>
        </div>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body class="pt-0">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col>
                      <h4 class="card-title">Search by</h4>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-input
                          id="exampleInputText1"
                          type="text"
                          placeholder="enter user's name, email or organization"
                          size="sm"
                          v-model="search"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </div>
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body>
              <b-table
                hover
                responsive
                :items="items"
                :fields="fields"
                class="mb-0 table-borderless"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="loading"
                data-cy="users-table"
                sort-icon-left
              >
                <template #table-busy>
                  <div class="text-center p-4" style="color: var(--iq-primary)">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(prettyName)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(organizationName)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(action)="data">
                  <b-button
                    variant="outline-danger mr-2"
                    size="sm"
                    @click="toDeleteItem = data"
                  >
                    Remove
                  </b-button>
                </template>
              </b-table>
            </template>
          </iq-card>
        </b-col>
      </div>
      <div class="row d-flex justify-content-center">
        <b-pagination
          value="3"
          size="md"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>
      <b-modal
        id="delete-modal"
        :visible="!!toDeleteItem"
        title="Remove user from organization"
        @hidden="toDeleteItem = null"
      >
        <p v-if="toDeleteItem">
          User <strong>{{ toDeleteItem.item.prettyName }}</strong> will be removed from organization <strong>{{ toDeleteItem.item.organizationName }}</strong>.
        </p>
        <p>Are you sure?</p>
        <template #modal-footer="{}">
          <b-button
            size="sm"
            variant="outline-dark"
            @click="toDeleteItem = null"
            >Cancel</b-button
          >
          <b-button size="sm" variant="danger" @click="deleteItem(toDeleteItem.item.id)"
            >Remove</b-button
          >
        </template>
      </b-modal>
      <b-modal
        :visible="toAddModalOpened"
        title="Add user to organization"
        @hidden="toAddModalOpened=false"
        hide-footer
      >
        <FormulateForm
          name="addUserOrganization"
          @submit="submitHandler"
          v-model="formValues"
                  >
                    <b-row>
                      <b-col>
                        <b-form-group label="User" label-for="userId">
                          <FormulateInput
                            id="userId"
                            name="userId"
                            type="select"
                            input-class="form-control"
                            validation="required"
                            placeholder="Choose user"
                            validation-name="User"
                            :disabled="isUpdating"
                            :options="
                              users.map((d) => ({
                                value: d.id,
                                label: d.prettyName,
                              }))
                            "
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>                  
                    <b-row>
                      <b-col>
                        <b-form-group label="Organization" label-for="organizationId">
                          <FormulateInput
                            id="organizationId"
                            name="organizationId"
                            type="select"
                            input-class="form-control"
                            validation="required"
                            placeholder="Choose organization"
                            validation-name="Organization"
                            title="asdasd"
                            :disabled="isUpdating"
                            :options="
                              organizations.map((d) => ({
                                value: d.id,
                                label: d.name,
                              }))
                            "
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group label="Set as default" label-for="isDefault">
                        <div
                          class="
                            custom-control
                            custom-switch
                            custom-switch-text
                            custom-control-inline
                            custom-switch-color
                          "
                        >
                          <div class="custom-switch-inner">
                            <input
                              type="checkbox"
                              class="custom-control-input bg-success"
                              :id="'customSwitch-11'"
                              v-model="formValues.isDefault"
                            />
                            <label
                              class="custom-control-label custom-control-label-big"
                              :for="'customSwitch-11'"
                            ></label>
                          </div>
                        </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="text-center">
                      <b-col>
                        <b-button
                          type="submit"
                          variant="primary"
                          data-cy="submit-button"
                          class="mt-2 mb-2"
                          @click="addUserOrganization"
                          >Add user to organization</b-button
                        >
                      </b-col>
                    </b-row>
                  </FormulateForm>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { core } from "../../config/pluginInit";
import DeletedBadge from "./Components/DeletedBadge";
import formatGQLError from "../../Utils/formatGQLError";
import gql from "graphql-tag";
import { prettyName } from '../../Utils/getOwnerData';
const LIST_USERS = gql`
  query listUsers {
    users {
      id
      first_name
      last_name
      email
    }
  }
`;
const LIST_ORGANIZATIONS = gql`
  query listOrganizations {
    organizations {
      id
      name
    }
  }
`
const LIST_USER_ORGANIZATIONS = gql`
  query listUserOrganizations(
    $where: user_organization_bool_exp
    $limit: Int
    $offset: Int
    $order_by: [user_organization_order_by!]
  ) {
    user_organization(
      where: $where,
      limit: $limit,
      offset: $offset
    ) {
      id
      user {
        id
        first_name
        last_name
        email
      }
      organization {
        id
        name
      }
      default
    }
    user_organization_aggregate{
      aggregate {
        count
      }
    }
  }
`;
const DELETE_USER_ORGANIZATION = gql`
  mutation deleteUserOrganization($id: uuid!) {
    delete_user_organization_by_pk(id: $id){
      id
    }
  }
`;
const ADD_USER_ORGANIZATION = gql`
  mutation addUserOrganization(
    $userId: uuid!,
    $organizationId: uuid!,
    $default: Boolean!,
  ){
    insert_user_organization_one(
      object: {
        user_id: $userId,
        organization_id: $organizationId,
        default: $default
      }
    ){
      id
      user_id
      organization_id
      default
    }
  }
`;
export default {
  name: "UserOrganizations",
  data() {
    return {
      sortBy: "email",
      sortDesc: false,
      search: "",
      perPage: 25,
      currentPage: 1,
      rows: null,
      users: [],
      error: false,
      loading: false,
      items: [],
      fields: [
        { key: "prettyName", label: "User", sortable: false },
        { key: "organizationName", label: "Organization", sortable: false },
        { key: "default", label: "Default", sortable: false },
        { key: "action", label: "Actions", sortable: false }
      ],
      toDeleteItem: null,
      toAddModalOpened: false,
      formValues: {
        userId: "",
        organizationId: "",
        isDefault: false,
      }
    };
  },
  components: {
    DeletedBadge
  },
  apollo: {
    userOrganizations: {
      query: LIST_USER_ORGANIZATIONS,
      fetchPolicy: "no-cache",
      variables() {
        const vars = {
          where: {},
          limit: this.perPage,
          offset: this.currentPage * this.perPage - this.perPage
        };

        // filter
        const searchPart = this.search
          ? {
              _or: [
                {
                  user: {
                    first_name: {
                      _ilike: `%${this.search}%`
                    }
                  }
                },
                {
                  user: {
                    last_name: {
                      _ilike: `%${this.search}%`
                    }
                  }
                },
                {
                  user: {
                    email: {
                      _ilike: `%${this.search}%`
                    }
                  }
                },
                {
                  organization: {
                    name: {
                      _ilike: `%${this.search}%`
                    }
                  }
                },
              ]
            }
          : null;

        const whereAttributes = [];

        const finalFilter = [];
        if (searchPart !== null) {
          finalFilter.push(searchPart);
        }
        if (whereAttributes.length > 0) {
          whereAttributes.forEach(att => finalFilter.push(att));
        }

        vars.where = {
          _and: finalFilter
        };

        return vars;
      },
      result({ data, loading, networkStatus }) {
        if (!loading) {
          this.rows = data.user_organization_aggregate.aggregate.count;
          this.items = data.user_organization.map(userOrganization => {
            return {
              id: userOrganization.id,
              prettyName: prettyName(userOrganization.user.first_name, userOrganization.user.last_name, userOrganization.user.email),
              organizationName: userOrganization.organization.name,
              default: userOrganization.default ? 'YES' : 'NO'
            };
          });
        }
      }
    },
    users: {
      query: LIST_USERS,
      update: data => data.users.map(i => ({
        ...i,
        prettyName: prettyName(i.first_name, i.last_name, i.email)
      }))
    },
    organizations: {
      query: LIST_ORGANIZATIONS
    }
  },
  computed: {
    // items() {
      // return this.userOrganization
      // const d = this.userOrganizations.map(userOrganization => {
      //   return {
      //     id: userOrganization.id,
      //     prettyName: prettyName(userOrganization.user.first_name, userOrganization.user.last_name, userOrganization.user.email),
      //     organizationName: userOrganization.organization.name
      //   };
      // });
      // console.log(this.userOrganizations);
      // return d;
    // },
    toDeleteUserOrganization() {
      if (!this.toDeleteItem) {
        return null;
      }
      const u = this.items.find(i => i.id === this.toDeleteItem);
      if (!u) {
        return null;
      }
      return u;
    }
  },
  methods: {
    async deleteItem(id) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_USER_ORGANIZATION,
          variables: {
            id
          }
        });
        this.$toast.success(`User in organization deleted`);
        this.toDeleteItem = null;
        this.$apollo.queries.userOrganizations.refetch();
      } catch (error) {
        this.$toast.error(`Failed to delete user in organization: ${error.message}`);
      }
    },
    async addUserOrganization(){
      try {
        await this.$apollo.mutate({
          mutation: ADD_USER_ORGANIZATION,
          variables: {
            userId: this.formValues.userId,
            organizationId: this.formValues.organizationId,
            default: this.formValues.isDefault
          }
        });
        this.$toast.success(`User added to organization.`);
        this.formValues = {
          userId: "",
          organizationId: "",
          isDefault: false,
        };
        this.$apollo.queries.userOrganizations.refetch();
      } catch (error) {
        this.$toast.error(`Failed to add user to organization: ${error.message}`);
      }
      this.toAddModalOpened = false;
    }
  },
  mounted() {
    core.index();
  }
};
</script>
